const TreeNode = require('./TreeNode');

const YesNoNode = function (actor, battleState, altNode) {
  var node = new TreeNode(actor, battleState, altNode);

  // branch indexes
  node.NO = 0;
  node.YES = 1;

  node.query = function (input) {
    if (node.yesNoEvalFunction(input)) {
      return this.branches[this.YES].query(input);
    } else {
      return this.branches[this.NO].query(input);
    }
  };

  return node;
};
module.exports = YesNoNode;
